"use strict";
/**
 * Google Analytics v4
 * see https://redbox.outletcity.com/confluence/display/TUB/Google+Analytics+4+%28GA4%29+E-Commerce+Tracking
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushGA4CustomEvent = exports.pushGA4Event = void 0;
const dataLayer_1 = __importDefault(require("./dataLayer"));
const pushGA4Event = (name, payload) => {
    const event = {
        event: name,
        ga4_ecommerce: payload,
    };
    (0, dataLayer_1.default)(event, { clearEcommerceObject: true });
};
exports.pushGA4Event = pushGA4Event;
const pushGA4CustomEvent = (name, payload) => {
    const event = Object.assign({ event: name, category: undefined, action: undefined, label: undefined, attributes: undefined, type: undefined }, payload);
    (0, dataLayer_1.default)(event);
};
exports.pushGA4CustomEvent = pushGA4CustomEvent;
